module.exports = __webpack_public_path__ + "static/assets/525f9f117c5f92c510e48551d6adea4d.png";